import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import classes from './layout.module.scss';
import Header from '../Header/Header';
import NavBar from '../NavBar/NavBar';
import { getAccountRequest } from '../../store/actions/auth';
import { setScrollingToNoteId } from '../../store/actions/script';
import accountHelpers from '../../utils/accountHelpers';

let prevPath = '';

const Layout = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isAuthorized, account } = useSelector((store) => store.auth);
  const { scrollingToNoteId } = useSelector((store) => store.script);

  const userId = account?.id;
  const dispatch = useDispatch();

  const isScriptViewUrl = /^\/scripts\/\d+\/?(\?.*)?$/i.test(pathname);

  useEffect(() => {
    if (pathname === '/') {
      if (isAuthorized) {
        if (account.role.includes('Physician') || account.role.includes('Health')) {
          navigate('/patients', { replace: true });
        } else if (account.role.includes('Patient')) {
          navigate(`/patients/${accountHelpers.getUser()?.patientId}`, { replace: true });
        } else {
          navigate('/scripts', { replace: true });
        }
      } else {
        navigate('/login', { replace: true });
      }
    }
  }, [pathname]);

  useEffect(() => {
    if (isAuthorized && prevPath !== '/login') {
      dispatch(getAccountRequest(userId));
    }

    if (scrollingToNoteId && !isScriptViewUrl) {
      dispatch(setScrollingToNoteId(null));
    }

    prevPath = pathname;
  }, [pathname]);

  const wrapper = [classes.layout_wrapper];

  if (isAuthorized) wrapper.push(classes.with_right_bar);

  return (
    <div className={wrapper.join(' ')}>
      {isAuthorized && (
        <>
          <Header account={account} />

          {!account.role.includes('Patient') && <NavBar />}
        </>
      )}

      <div className={classes.content_wrapper}>
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;
